document.addEventListener("DOMContentLoaded", function(event) { 

    $('body').append(`
        <div id="__blockui" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(255, 255, 255, 0.5); z-index: 9999; justify-content: center; align-items: center; display: none;">
            <span class="fas fa-cog fa-spin fa-3x" style="color: #444"></span>
        </div>
    `);

});

export let blocked = false;

export function block(){
    blocked = true;
    $('#__blockui').css('display', 'flex');
}

export function release(){
    $('#__blockui').css('display', 'none');
    blocked = false;
}